import gql from "graphql-tag";

export default gql`
  fragment MovieListFragment on Movie {
    id
    name
    tmdbOptions
    isViewable
  }
`